import { AxiosError, AxiosResponse } from 'axios';
import { observable, runInAction } from 'mobx';
import { Notice, UiResponse } from '../CommonInterfaces';
import { UI_LOGOUT_PAGE_PATH } from '../Routes';
import { API } from '../util/ApiUtil';
import ErrorUtil from '../util/ErrorUtil';
import RootStore from './RootStore';
import RouteStore from './RouteStore';
import UiStore from './UiStore';

export default class LogoutStore {
  @observable accessor notice: Notice | null = null;
  private routeStore: RouteStore;
  private uiStore: UiStore;

  constructor(rootStore: RootStore) {
    this.routeStore = rootStore.routeStore;
    this.uiStore = rootStore.uiStore;
  }

  public logOut = () => {
    runInAction(() => {
      this.notice = null;
    });
    return API.post(`/logout${this.routeStore.formForwardParams}`).then(this.handleSuccess).catch(this.handleError);
  };

  private handleError = (e: AxiosError) => {
    ErrorUtil.pushErrorToTeliaRumAndLog(e);
    this.uiStore.handleNotice(e.response);
  };

  private handleSuccess = (response: AxiosResponse<UiResponse>) => {
    if (this.routeStore.decodedParams?.webapi) {
      this.routeStore.route(UI_LOGOUT_PAGE_PATH);
      return;
    }
    if (response.data.redirectUrl) {
      if (!response.data.redirectUrl.startsWith('/')) {
        return (window.top!.location.href = response.data.redirectUrl);
      } else {
        this.routeStore.route(response.data.redirectUrl);
      }
    }
    this.uiStore.handleNotice(response);
  };
}
